<template>
  <form class="mt-2" id="form-modal">
    <!-- description input -->
        <div class="form-group">
            <label>Select User<span style="color: red">*</span>:</label>
        <select class="form-control py-0" name="template" v-model="selected">
                <option v-for="item in adminUsers" v-bind:key="item.id" :value="item.id">
                {{ item.first_name }} {{item.last_name}}
            </option>
        </select>
        </div>
        <div class="form-group">
            <label>Note<span style="color: red">*</span>:</label>
            <textarea class="form-control" style="height: 200px" v-model="note_description"
            placeholder="write a reason to transfer lead">
            </textarea>
       </div>
    <!-- buttons -->
    <div class="form-footer text-right">
      <button type="button" class="btn btn-secondary text-light btn-sm" data-dismiss="modal">
        Close
      </button>
      <button type="button" :disabled="isMiniLoading" :style= "[isMiniLoading ? { 'cursor' : 'default' } : { 'cursor' : 'pointer' }]" class="btn btn-success text-light btn-sm ml-1" @click="save()">
        <font-awesome-icon v-if="isMiniLoading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
        Transfer Lead
      </button>
    </div>

    
  </form>
</template>

<script>
  import axios from "axios";
  import Multiselect from "vue-multiselect";
  export default {
    components: {
      Multiselect
    },
    props: ["action", "formData", "pageNumber", "status"],
    data: function () {
      return {
       adminUsers: [],
       isMiniLoading: false,
       selected: "",
       note_description:"",
       trial_history:"",
      };
    },
    created: function () {
        const permission = {
        headers: {
          'X-Permission': 'lead_transfer' 
        }
      };
      
     axios.get('/admin/users/get-all-users-crm?role_id=' + 2,permission)
      .then((response) => {
        let res = response.data;
        this.adminUsers = res.data;
      });
    },
    computed :{
    },
    methods: {
      save() {
        this.isMiniLoading = true;
        let page_no = this.formData.pageNumber;
        let lead_id = this.formData.lead_id;
        let selected = this.selected;
        let note_description = this.note_description;
        if(note_description ==null || note_description ==""){
            this.$toast.warning("Add a reason to Assign Lead to this User");
        }
        if(selected == null || selected == ""){
            this.$toast.warning("Please Select User First");
        }
        
        if (this.selected != null && this.selected != "" && this.note_description != null && this.note_description != "") {
           const permission = {
        headers: {
          'X-Permission': 'lead_transfer' 
        }
      };
         axios.post("/admin/users/transfer-lead", {
              user_id:this.selected,
              note_description:this.note_description,
              role:2,
              lead_id:lead_id,
            },permission)
            .then(() => {
              this.isMiniLoading = false;
              this.$toast.success("Lead Transfer Successfully!");
              this.selected = "";
              this.note_description = "";
              window.$("#modal").modal("hide");
              if(this.formData.flag == false){
                setTimeout(() => {
                  let loader = this.$loading.show({
          loader: 'dots',
        });
                    window.location.reload();
                }, 1000)
                
              }
              this.$store.dispatch("users/getAllDemoRequests", [page_no,"", this.formData.status, "","", "", "", "", "", this.formData.color ? this.formData.color : "", 'all', 'all', 'all']);
            })
            .catch((error) => {
              this.isMiniLoading = false;
              this.$toast.error(error);
            });
        } else {
          this.isMiniLoading = false;
        //   this.$toast.warning("Please Select User First");
        }
      },

    },
  };
</script>